// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1qCxp","footer":"ReportModalFilter_footer__2jkNg"};